export default __webpack_public_path__ + "static/media/robot.b30c6cf0.png";